import anime from 'animejs/lib/anime.es.js';
import scrollLock from 'scroll-lock';
export default class Menu {
	constructor() {
		this.headerWrapper = document.querySelector('[data-header-wrapper]');
		this.hamburger = this.headerWrapper.querySelector('[data-hamburger]');
		this.slideOut = this.headerWrapper.querySelector('[data-slide-out-menu]');
		this.menu = this.slideOut.querySelector('[data-menu]');

		this.hamburger.addEventListener('click', e => {
			this.toggleMenu();
		});

		this.breakpoint = window.matchMedia('(max-width:991px)');

		this.slideOutOpen = false;
		this.isAnimating = false;		

		let focusableElements = this.menu.querySelectorAll('li');

		this.firstTarget = focusableElements[0];
		this.lastTarget = focusableElements[focusableElements.length - 1];

		this.firstFocusableEl = this.firstTarget.firstElementChild;
		this.lastFocusableEl = this.lastTarget.firstElementChild;

		window.addEventListener('keydown', e => {
			if (e.key === 'Escape') {
				if(this.slideOutOpen){
					this.closeMenu();
				}
			}

			if (e.key === 'Tab' || e.key === 9) {
				if(this.slideOutOpen) {
					if (e.shiftKey) /* shift + tab */ {
						if (document.activeElement === this.firstFocusableEl) {
							this.lastFocusableEl.focus();
							e.preventDefault();
						}
					} else /* tab */ {
						if (document.activeElement === this.lastFocusableEl) {
							this.firstFocusableEl.focus();
							e.preventDefault();
						}
					}
				}
			}
		});
	}

	toggleMenu() {
		this.slideOutOpen ? this.closeMenu() : this.openMenu();
	}

	openMenu() {
		if(this.isAnimating|| this.slideOutOpen) {
			return;
		}

		this.slideOutOpen = true;
		this.isAnimating = true;

		scrollLock.disablePageScroll();


		this.hamburger.classList.add('is-active');
		this.hamburger.setAttribute('aria-expanded', true);

		anime.set(this.headerWrapper, {
			zIndex: 9999
		});

		anime.set(this.slideOut, {
			visibility: 'visible',
		});

		anime.set(this.pageOverlay, {
			visibility: 'visible',
		});

		const tl = anime.timeline({
			easing: 'easeInOutSine',
			duration: 500,
		});

		if (this.breakpoint.matches === true) {
			// Mobile
			tl.add({
				targets: this.slideOut,
				translateX: '-100%'
			}).add({
				targets: this.menu,
				opacity: 1
			});
		} else {
			// Desktop
			tl.add({
				targets: this.pageOverlay,
				opacity: 0.3,
			})
			.add({
				targets: this.slideOut,
				translateX: '-40vw'
			}, '-=50')
			.add({
				targets: this.menu,
				opacity: 1,
			});
		}

		tl.finished.then(() => {
			this.isAnimating = false;

			this.firstFocusableEl.focus();
		});

	}

	closeMenu() {
		if (this.isAnimating || !this.slideOutOpen) {
			return;
		}

		this.isAnimating = true;

		this.hamburger.classList.remove('is-active');

		const tl = anime.timeline({
			easing: 'easeInOutSine',
			duration: 500
		});


		if (this.breakpoint.matches === true) {
			// Mobile
			tl.add({
				targets: this.menu,
				opacity: 0,
			}).add({
				targets: this.slideOut,
				translateX: '0'
			});
		}else{
			// Desktop
			tl.add({
				targets: this.menu,
				opacity: 0,
			}).add({
				targets: this.slideOut,
				translateX: '0'
			}).add({
				targets: this.pageOverlay,
				opacity: 0,
			},'-=50');
		}


		tl.finished.then(() => {
			this.slideOutOpen = false;
			this.isAnimating = false;

			anime.set(this.slideOut, {
				visibility: 'hidden',
			});

			anime.set(this.pageOverlay, {
				visibility: 'hidden',
			});

			anime.set(this.headerWrapper, {
				zIndex: 999
			});

			scrollLock.enablePageScroll();

			this.hamburger.setAttribute('aria-expanded', false);
			this.hamburger.focus();
		});
	}	
}
